import InsightsCaughtUp from '@static/images/empty-state/insights-caught-up.svg';
import { FollowingInsightFeedFilterTabs } from '@terminal/views/insight-feed/components/insight-feed-type-tab-line/InsightFeedTypeTabLine';
import { useTranslation } from 'react-i18next';

import { OverviewEventFeedPeriod } from '../../utils';
import styles from './NoEvents.module.scss';

const NO_EVENTS_CONTENT_KEY: Record<FollowingInsightFeedFilterTabs, string> = {
  all: 'noEventsContent_all',
  company_catalyst: 'noEventsContent_company_catalyst',
  scenarios: 'noEventsContent_scenarios',
  earnings: 'noEventsContent_earnings',
};

export const NoEvents = ({
  activeTab,
  period,
  isNonStock = false,
  isCountryMacroContext = false,
}: {
  activeTab: FollowingInsightFeedFilterTabs;
  period: OverviewEventFeedPeriod;
  isNonStock?: boolean;
  isCountryMacroContext?: boolean;
}) => {
  const { t } = useTranslation(['whatsNew']);

  const title = t('whatsNew:noEventsEmpty', {
    /* i18next-extract-mark-context-next-line  ["all", "company_catalyst", "scenarios", "earnings"] */
    content:
      isNonStock && activeTab === 'company_catalyst'
        ? isCountryMacroContext
          ? t('whatsNew:noEventsContent_countryMacroContext')
          : t('whatsNew:noEventsContent_directMarketCatalysts')
        : t(`whatsNew:${NO_EVENTS_CONTENT_KEY[activeTab]}`),
    /* i18next-extract-mark-context-next-line  ["1D", "3D", "1W", "1M"] */
    periodRange: t(`whatsNew:noEventsPeriodRange_${period}`),
  });

  return (
    <div className={styles.root} data-testid="overview-event-feed-no-insights">
      <InsightsCaughtUp width="56px" height="56px" />
      <div className={styles.descriptionText}>
        <div className={styles.titleText}>{title}</div>
      </div>
    </div>
  );
};
